import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // force jump to top every route change
  }, [location.pathname, location.search, location.hash]);

  return null;
};

export default ScrollToTop;
